import { Pipe, PipeTransform } from '@angular/core';

/**
 * 住所文字列結合パイプ
 *
 * @export
 * @class BillDispZyuusyoPipe
 * @implements {PipeTransform}
 */
@Pipe({
  name: 'billDispZyuusyo'
})
export class BillDispZyuusyoPipe implements PipeTransform {
  
  /**
   * 住所の各項目を含むDTOごと受け取る
   *
   * @param {*} value
   * @param {string} prefix
   * @return {*}  {string}
   * @memberof BillDispZyuusyoPipe
   */
  transform(value: any, prefix?: string): string {
    let editedValue: string = '';
    if(!prefix){
      if(value[prefix + 'Postno']) editedValue = value[prefix + 'Postno'] + ' ';
      if(value[prefix + 'SazvjjsKanjiAname']) editedValue += value[prefix + 'SazvjjsKanjiAname'] + ' ';
      if(value[prefix + 'SupadrKanjiAname1']) editedValue += value[prefix + 'SupadrKanjiAname1'] + ' ';
      if(value[prefix + 'YagyomoKanji']) editedValue += value[prefix + 'YagyomoKanji'];
    }
    if(value.postno) editedValue = value.postno + ' ';
    if(value.sazvjjsKanjiAname) editedValue += value.sazvjjsKanjiAname + ' ';
    if(value.supadrKanjiAname1) editedValue += value.supadrKanjiAname1 + ' ';
    if(value.yagyomoKanji) editedValue += value.yagyomoKanji;
    return editedValue;
  }

}
